import { PageHeader } from "@shared/components/PageHeader";
import { Tabs } from "@shared/ui/tabs";
import { PersonalInfoLanding } from "./tabs/personal-info/PersonalInfoLanding";
import { PlanDepositLanding } from "./tabs/plan-deposit/PlanDepositLanding";
import { ServicesMetersLanding } from "./tabs/services-meters/ServicesMetersLanding";
import { PreferencesLanding } from "./tabs/preferences/PreferencesLanding";
import PlanAndDeposit from "../../shared/components/PlanAndDeposit";
import DocumentLandingTab from "./tabs/documents-contracts/DocumentsContractsLanding";
import { useTranslation } from "react-i18next";

export const ProfileLanding=()=>{
     const { t } = useTranslation();
     const tabComponents = {
    personal_info: {
      label: t("Personal Info"),
      shortLabel: t("Personal Info"),
      component: <PersonalInfoLanding />
    },
    plan_deposit: {
      label: t("Plan & Deposit"),
      shortLabel: t("Plan & Deposit"),
      component: <PlanAndDeposit />
    },
    services_meters: {
      label: t("Services & Meters"),
      shortLabel: t("Services & Meters"),
      component: <ServicesMetersLanding />
    },
    documents_contracts: {
      label: t("Documents & Contracts"),
      shortLabel: t("Documents & Contracts"),
      component: <DocumentLandingTab />
    },
    preferences: {
      label: t("Preferences"),
      shortLabel: t("Preferences"),
      component: <PreferencesLanding />
    },
  };

  const urlMapping = {
    personal_info: "personal_info",
    plan_deposit: "plan_deposit",
    services_meters: "services_meters",
    documents_contracts: "documents_contracts",
    preferences: "preferences",
  };

     return (
 <div className="p-6 space-y-6">
  <PageHeader title={t("Profile & Settings")} subtitle={t("Manage your account information and preferences")}
  ></PageHeader>
 <Tabs 
        defaultValue="personal_info"
        tabComponents={tabComponents}
        urlMapping={urlMapping}
        tabsListClassName="grid grid-cols-5 w-full"
        idPrefix="personal_info-tab"
        className="space-y-4"
      />
  </div>
 );
}